import { FlowTrigger } from 'qx-flow-orm';

import { RULE_FIRED_TYPE } from '@/models/rule/constants/rule-fired';
import { FlowTriggerType, RuleCondition } from '@/models/rule/types';

export const buildRuleFiredConditions = (ruleId: string): RuleCondition[] => [
  {
    _and: [{ type: { _eq: RULE_FIRED_TYPE } }, { ruleID: { _eq: ruleId } }]
  }
];

const equalsValue = (clause: RuleCondition, field: string) => {
  const operand = clause[field];
  return Array.isArray(operand) ? undefined : operand?._eq;
};

export const extractRuleFiredId = (conditions: RuleCondition[]): string | null => {
  const group = conditions[0]?._and;
  if (!Array.isArray(group) || !group.some((clause) => equalsValue(clause, 'type') === RULE_FIRED_TYPE)) {
    return null;
  }

  const ruleId = group.map((clause) => equalsValue(clause, 'ruleID')).find((value) => value != null);
  return ruleId == null ? '' : String(ruleId);
};

export const isRuleFiredConditions = (conditions: RuleCondition[]) => extractRuleFiredId(conditions) !== null;

export const isRuleFiredTrigger = (trigger: FlowTrigger) =>
  'conditions' in trigger && trigger.type === FlowTriggerType.Event && isRuleFiredConditions(trigger.conditions);
